import * as React from "react";
import { ArrowLeft } from "lucide-react";
import { Button } from "@/components/ui/button";
import { trackActivity } from "@/utils/trackActivity";

export const SafeZonesView = ({ onBack }) => {
  React.useEffect(() => {
    trackActivity("view_module", "safe_zones");
  }, []);

  return (
    <div className="min-h-screen bg-white flex flex-col" data-testid="safe-zones-view">
      <header className="border-b bg-white sticky top-0 z-10 flex-shrink-0">
        <div className="max-w-7xl mx-auto px-4 py-2 flex items-center gap-3">
          <Button variant="ghost" size="sm" onClick={onBack} data-testid="safe-zones-back">
            <ArrowLeft className="h-4 w-4 mr-1" />
            Volver
          </Button>
          <div className="h-5 w-px bg-slate-200" />
          <span className="text-sm font-medium text-slate-700">AdOps Safe Zone Tool</span>
        </div>
      </header>
      <iframe
        src="/safe-zones.html"
        className="flex-1 w-full border-0"
        style={{ minHeight: "calc(100vh - 49px)" }}
        title="AdOps Safe Zone Tool"
      />
    </div>
  );
};
